module.exports = __webpack_public_path__ + "static/media/4.36814063.svg";